require('./index.scss')

import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import MediaQuery from 'react-responsive'

import screenSizes from '@/constants/screen_sizes'
import { actions as miniCartActions } from '@/reducers/miniCart'

import MiniCartDialog from './components/MiniCartDialog'
import Trigger from './components/Trigger'

const MiniCart = ({ hasMobileLayout, showEmptyCart }) => {
  const numberOfAssetsInCart = useSelector( state => state.cart.itemsTotalCount)
  const dispatch = useDispatch()
  const shouldShow = numberOfAssetsInCart > 0 || showEmptyCart

  const onOpen = () => {
    dispatch(miniCartActions.setIsShowing(true))
  }

  const mediaQueryProps = hasMobileLayout
    ? { maxWidth: screenSizes.sm_max }
    : { minWidth: screenSizes.md }

  return (
    <If condition={shouldShow}>
      <MediaQuery {...mediaQueryProps} >
        <div className='d-flex align-items-center'>
          <div className='mini-cart'>
            <Trigger {...{ onOpen }} />
            <MiniCartDialog />
          </div>
        </div>
      </MediaQuery>
    </If>
  )
}

export default MiniCart

MiniCart.propTypes = {
  hasMobileLayout: PropTypes.bool.isRequired,
  showEmptyCart: PropTypes.bool.isRequired
}
